// src/Login.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../Context/AuthContext"; // Import useAuth for context management

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(""); // State for error messages
  const { login } = useAuth(); // Use the login function from context
  const navigate = useNavigate(); // Use navigate for redirection

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Fetch user data from Firebase
      const response = await axios.get(
        "https://java-tutorial-c5fac-default-rtdb.firebaseio.com/JMeter_Users_data.json"
      );

      const users = response.data;
      const user = Object.values(users).find(
        (user) => user.email === email && user.password === password
      );

      if (user) {
        login(user); // Set the current user in the context
        console.log("User logged in:", user);
        navigate(`/dashboard?user=${user.firstName}`); // Redirect to the dashboard with user name
      } else {
        setError("Invalid email or password. Please try again."); // Set error message
      }
    } catch (error) {
      console.error("Error logging in:", error);
      setError("Error logging in. Please try again."); // Set error message
    }
  };

  return (
    <div className="container mt-5 d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
      <div className="card" style={{ width: '100%', maxWidth: '400px' }}>
        <div className="card-body">
          <h5 className="card-title text-center">Login</h5>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <input
                type="password"
                placeholder="Password"
                className="form-control"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && (
              <div className="alert alert-danger" role="alert">
                {error}
              </div>
            )}
            <button type="submit" className="btn btn-primary w-100">
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
